import {
  GET_SDK_FILE
} from '../constants/download';

export const getSDKFile = (file, cb) => ({ 
  type: GET_SDK_FILE,
  payload: Object.assign( {}, { requestMethod:'GET', requestPath: `api/Download/sdk/${file}`}, {callback: cb})
});